export function variable (variable) {
  return '?' + variable.value // TODO: escape special chars
}
